import React from 'react';
import { Container } from '@/components/ui/Container';
import { Button } from '@/components/ui/Button';
import KPICard from '@/components/ui/analytics/KPICard';
import {
  LayoutWrapper,
  HeaderSection,
  Title,
  Description,
  ActionArea,
  CardsGrid,
} from './ListBodyLayout.style';

/**
 * Reusable body layout used on list‑style pages (e.g., Projects).
 *
 * Props:
 * - `title`: main heading text.
 * - `description`: optional sub‑text beneath the title.
 * - `actions`: optional React node (usually a primary button) displayed to the right of the header.
 * - `kpiCards`: array of objects `{ title, value, change }` used to render KPI cards.
 * - `children`: any additional content rendered below the KPI section.
 */
export default function ListBodyLayout({
  title,
  description,
  actions,
  kpiCards = [],
  children,
}) {
  return (
    <LayoutWrapper>
      <HeaderSection>
        <Container $display="flex" $flexDirection="column" $gap="4px">
          <Title>{title}</Title>
          {description && <Description>{description}</Description>}
        </Container>
        {actions && <ActionArea>{actions}</ActionArea>}
      </HeaderSection>

      {kpiCards.length > 0 && (
        <CardsGrid $columns={kpiCards.length} $rows={1} $gap="24px">
          {kpiCards.map((card, idx) => (
            <KPICard key={idx} {...card} />
          ))}
        </CardsGrid>
      )}

      {children}
    </LayoutWrapper>
  );
}
